export const ttd_endpoint = {
    search:'content/search',
    ContentPool:'content',
    save:'content',
    contentList:'content/get-all',
    custom_categories:'categories',
}